import React from "react";
import { RealTimeDashboard as RealTimeDashboardComponent } from "@/components/RealTimeDashboard";

export default function RealTimeDashboard() {
  return <RealTimeDashboardComponent />;
}
